//Service
import { downloadDoc } from 'services/docActions';

// Types
import { DownloadDocPayload } from 'services/types';

// Utils
import { previewFile } from 'utils/common';

const useDocActions = () => {
  const downloadDocWrapper = async ({
    queryString,
  }: Omit<DownloadDocPayload, 'auth'>) => {
    const response = await downloadDoc({ queryString });
    return response;
  };
  const previewDoc = (doc: any) => async () => {
    const { docKey, file } = doc;
    if (file) previewFile(URL.createObjectURL(file));
    else {
      const response = await downloadDoc({ queryString: { docKey } });
      if (response?.docUrl) previewFile(response?.docUrl);
    }
  };
  return {
    downloadDoc: downloadDocWrapper,
    previewDoc,
  };
};

export default useDocActions;
